import { AlertMessage } from './alert-types';
import { AlertService } from './alert.service';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'alert-panel',
    templateUrl: './alert-panel.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class AlertPanelComponent implements OnInit {

    alertMessages: AlertMessage[] = [];

    constructor(
        private readonly alertService: AlertService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }
    ngOnInit(): void {
        this.alertService.alerts$.subscribe(alert => {
            this.alertMessages.push(alert);
            if (alert.timeToDisplay && alert.timeToDisplay > 0) {
                this.createTimer(alert);
            }
            this.changeDetectorRef.detectChanges();
        });
    }

    dismissMessage(alert: AlertMessage): void {
        alert.dismissed = true;
        this.changeDetectorRef.detectChanges();
    }

    removeMessage(alert: AlertMessage): void {
        this.alertMessages.splice(this.alertMessages.indexOf(alert));
        this.changeDetectorRef.detectChanges();
    }

    createTimer(alert: AlertMessage) {
        setTimeout(() => this.dismissMessage(alert), alert.timeToDisplay);
    }

}
